import PropTypes from "prop-types";
import React, { useState } from "react";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import ProductCard from "web/react/components/product-card/product-card";
import Rail from "web/react/components/rail/rail";
import { LOADING_STATES, useRothko } from "web/react/hooks/use-rothko/use-rothko";
import styles from "./ajax-product-rail.css";

function AjaxProductRail({
    className,
    endpoint,
    features,
    hiddenProductsCount,
    label,
    productSlug,
    productUid,
    railClassName,
    title,
}) {
    const [rothkoOptions] = useState({ slug: productSlug, uid: productUid });
    const { data, loadingState } = useRothko(endpoint, rothkoOptions);

    return (
        <>
            {loadingState == LOADING_STATES.COMPLETE && data.related_products.length > 0 ? (
                <Rail
                    className={className}
                    title={title}
                    seeAllLink={data && data.view_more_url}
                    analyticsLabel={label}
                    sendAnalytics={!!data.related_products.length}
                    railClassName={railClassName}
                    railsMoreButtonPlacement={features.uj_rails_more_button_placement}
                    railMoreVariant={features.uj_rail_more_variant}
                    showExtraRailItem={features.uj_show_extra_rail_item}
                >
                    {data.related_products.map((product, index) => {
                        return (
                            <ProductCard
                                className={styles.productCard}
                                key={product.id}
                                product={product}
                                hideOnDesktop={index < hiddenProductsCount ? true : false}
                            />
                        );
                    })}
                </Rail>
            ) : loadingState == LOADING_STATES.PENDING ? (
                <div className={styles.loadingWrapper}>
                    <LoadingSpinner />
                </div>
            ) : null}
        </>
    );
}

AjaxProductRail.propTypes = {
    className: PropTypes.string,
    endpoint: PropTypes.string.isRequired,
    features: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])),
    hiddenProductsCount: PropTypes.number,
    label: PropTypes.string.isRequired,
    productSlug: PropTypes.string.isRequired,
    productUid: PropTypes.string.isRequired,
    railClassName: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default AjaxProductRail;
